// extracted by mini-css-extract-plugin
export default {"fs":"_20f35df479 _51235b7cbb"};